import { render, staticRenderFns } from "./I.vue?vue&type=template&id=190a1278&scoped=true&"
import script from "./I.vue?vue&type=script&lang=ts&"
export * from "./I.vue?vue&type=script&lang=ts&"
import style0 from "./I.vue?vue&type=style&index=0&id=190a1278&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190a1278",
  null
  
)

export default component.exports